/**
 * The FileType enum. The enum values are the icon filenames.
 */
export enum FileType {
	Svg = "svg.svg",
	Img = "img.svg",
	Sheet = "sheet.svg",
	Pdf = "pdf.svg",
	Default = "file.svg",
}
